import React, { useEffect, useState, Suspense } from "react";
import { styled } from "../../stitches.config";
import { h1, bodyLarge } from "../commonStyles/Fonts";
import SubscribeButton from "../SubscribeButton";
import AuthorLinkIcon from "../assets/icons/author-link-icon.svg";
import { useStores } from "../../helpers";
import { observer } from "mobx-react";
import { observable } from "mobx";
import Loader from "../../components/Loader";
import HtmlParser from "../../components/Article/Content/HtmlParser";
import Title from "../atoms/Title";
import ArticleListItem from "../components/ArticleListItem";
import RecruitmentBox from "../components/RecruitmentBox";
import Media from "../../components/common/Media";
import Button from "../atoms/Button";
import { Sticky, StickyContainer } from "react-sticky";
import Breadcrumbs from "../components/Breadcrumbs";
import useMediaQuery from '../../helpers/useMediaQuery';

import { DISABLE_PREMIUM_FLAG_ACTIVE, IS_FEATURE_TIP } from "../../components/common/constants/constants";
import { ModalType } from "../Modal/config";
import ModalLink from "../Modal/ModalLink";
import { PaymentStatus, PaymentType } from "../types/Payment";
import TipCallToAction from "../Modal/payment/TipCallToAction";
import TipFormStandalone from "../Modal/payment/TipFormStandalone";
import { useParams } from "react-router-dom";
import SlateRenderer from "../../components/Article/Parts/Slate/SlateRenderer";

import PageCover from '../components/PageCover';
import Footer from "../components/Footer"

interface ILastPosts {
  title: string;
  lead: string;
  category: {
    name: string;
  };
  picture: {
    img: string;
    alt: string;
  };
  url: string;
}

const AuthorPage: React.FC = observer((props) => {
  const { UserStore, ArticleStore } = useStores();
  const [complexState] = useState(() => observable(UserStore));
  const [stateMobx] = useState(() =>
    observable({
      nextPage: "",
      pending: false,
      hideButton: false,
      posts: [],
    })
  );

  const isDesktop = useMediaQuery('bp4');
  const params = useParams();

  // dla SSR musi się wykonać także poza useEffect
  const { slug } = params;
  UserStore.updateSlug(slug);

  useEffect(() => {
    // @ts-ignore
    const { slug } = params;
    UserStore.updateSlug(slug);
    // @ts-ignore
  }, [params]);

  useEffect(() => {
    if (complexState.fetchedUser.user) {
      stateMobx.nextPage = `${window.API_HOST}/pwa-user/${complexState.currentSlug}?to_date=${encodeURIComponent(complexState.fetchedUser.LAST_POSTS_LAST_DATE)}`;
      stateMobx.posts = complexState.fetchedUser.user.last_posts;
    }
  }, [complexState.fetchedUser]);

  const { user } = complexState.fetchedUser;

  if (complexState.status === "loading") {
    return <Loader />;
  }

  const fetchPosts = ({ url }: { url: string }) => {
    stateMobx.pending = true;
    fetch(url)
      .then((res) => {
        if (!res.ok) return Promise.reject();
        return res.json();
      })
      .then((res) => {
        stateMobx.pending = false;
        if (typeof res.LAST_POSTS_LAST_DATE === "undefined") {
          stateMobx.hideButton = true;
        } else {
          stateMobx.nextPage = `${window.API_HOST}/pwa-user/${complexState.currentSlug}?to_date=${encodeURIComponent(res.LAST_POSTS_LAST_DATE)}`;
        }
        const posts = complexState.fetchedUser.user.last_posts;
        posts.length !== 0
          ? (stateMobx.posts = [...stateMobx.posts, ...res.user.last_posts] as [

          ])
          : (stateMobx.posts = res.user.last_posts);
        // console.log({ response, nextPage: nextPage })
      })
      .catch(() => {
        stateMobx.pending = false;
        // console.log("no match found")
      });
  };
  console.log(user)
  return (
    <>
      <PageCover
        beforeContent={(
          <Breadcrumbs
            category={{ name: "Skład redakcji", link: "/redakcja" }}
            subCategory={{ name: user.name, link: "" }}
            allWhite
          />
        )}
        title={(
          <>
            {user.name}
            {!DISABLE_PREMIUM_FLAG_ACTIVE && (
              <Suspense fallback={null}>
                <SubscribeButton
                  size="extraBig"
                  subscribed={false}
                  authorId={+user.OID}
                />
              </Suspense>
            )}
          </>
        )}
        description={user.aboutWysiwyg}
        isDescriptionWyswig={true}
        image={user.img}
      />
      <Container>
        <ContentWrapper>
          <ArticlesSection>
            <Title withDots size="large">
              Moje artykuły
            </Title>
            {stateMobx.posts?.map(
              (
                { title, lead, category, picture, url }: ILastPosts,
                index: number
              ) => (
                <>
                  <ArticleListItem
                    title={title}
                    lead={lead}
                    url={url}
                    categoryName={category.name}
                    picture={picture}
                  />
                  {index !== stateMobx.posts?.length - 1 && <ListSeparator />}
                  {index === 1 && IS_FEATURE_TIP && user.isRecentlyActive && (
                    <>
                      <TipFormStandalone
                        allAuthors={[user.OID]}
                        descriptionText="Teraz możesz docenić pracę dziennikarzy i dziennikarek. Cała kwota trafi do nich. Wraz z napiwkiem możesz przekazać też krótką wiadomość."
                        origin="tip-standalone-author"
                      />
                      <ListSeparator />
                    </>
                  )}
                </>
              )
            )}
            {!stateMobx.hideButton && (
              <ButtonWrapper>
                <Button
                  text="Pokaż więcej"
                  starPosition="none"
                  disabled={stateMobx.pending}
                  onClick={() => fetchPosts({ url: stateMobx.nextPage })}
                ></Button>
              </ButtonWrapper>
            )}
          </ArticlesSection>
          <SideSection>
            <StickyContainer style={{ height: "100%" }}>
              <Sticky topOffset={-91} style={{ height: "100%" }}>
                {({ style, isSticky }) => (
                  <StickyWrap isSticky={isSticky} style={style}>
                    <RecruitmentBox />
                  </StickyWrap>
                )}
              </Sticky>
            </StickyContainer>
          </SideSection>
        </ContentWrapper>
      </Container>
      <Footer />
    </>
  );
});

const StickyWrap = styled("div", {
  variants: {
    isSticky: {
      true: {
        paddingTop: "91px"
      },
      false: {}
    }
  }
});

const Container = styled("div", {
  margin: "0 auto",
  padding: "0 16px",
  "@bp3": {
    width: "960px",
  },
  "@bp4": {
    padding: "0 36px",
    width: "1160px",
  },
  "@bp6": {
    width: "1344px",
  },
});

const ContentWrapper = styled("div", {
  display: "flex",
  flexDirection: "column-reverse",
  "@bp4": {
    display: "grid",
    gridTemplateColumns: "1fr 300px",
    alignItems: "top",
    marginTop: "33px",
  },
});

const ListSeparator = styled("span", {
  display: "block",
  width: "100%",
  margin: "12px 0px 24px 0",
  "@bp4": {
    height: "1px",
    backgroundColor: "#E5E5E5",
    margin: "40px 0",
  },
});

const ArticlesSection = styled("div", {
  marginBottom: "40px",
  maxWidth: "840px",
});

const SideSection = styled("div", {
  display: "none",
  height: "100%",
  "@bp4": {
    display: "block",
    alignSelf: "flex-start",
    paddingTop: "58px",
  },
});

const ButtonWrapper = styled("div", {
  margin: "40px auto",
  display: "flex",
  justifyContent: "center",
});

export default AuthorPage;
